<div *ngIf="showBanner" class="cookie-consent-backdrop">
  <div class="cookie-consent-banner">
    <p>
      We use cookies and similar technologies to enhance your browsing
      experience, provide personalized content, analyze website traffic, and
      improve our services. Some cookies are essential for the website to
      function properly, while others help us understand how you use our site so
      we can make it better for you. By clicking
      <strong>‘Accept All’</strong>, you agree to the use of all cookies.
    </p>

    <div class="button-group row" *ngIf="!customizeMode">
      <button (click)="customizeCookies()" class="col">Customize</button>
      <button (click)="rejectAllCookies()" class="col">Reject all</button>
      <button (click)="acceptAllCookies()" class="col accept-button">
        Accept all cookies
      </button>
    </div>

    <div class="customize-options" *ngIf="customizeMode">
      <label>
        <input
          type="checkbox"
          [(ngModel)]="consent.functional"
          disabled
          checked
        />
        Functional Cookies (Always required)
      </label>

      <label>
        <input type="checkbox" [(ngModel)]="consent.analytics" />
        Analytics Cookies
      </label>

      <label>
        <input type="checkbox" [(ngModel)]="consent.marketing" />
        Marketing Cookies
      </label>

      <button (click)="savePreferences()" class="accept-button">
        Save Preferences
      </button>
      <button (click)="backToMain()" class="back-button">Back</button>
    </div>
  </div>
</div>
